<template>
  <span v-text="formatted" />
</template>

<script>
export default {
  name: 'FormattedAddress',

  props: {
    address: { required: true, type: Object }
  },

  computed: {
    formatted () {
      const parts = this.getAddressParts()
      const address = parts.join(', ')

      return address !== '' ? address : 'Not specified'
    }
  },

  methods: {
    getAddressParts () {
      const address = this.$_.pick(this.address, ['nameNumber', 'addressLine1', 'addressLine2', 'town', 'county', 'postcode'])
      const parts = []

      Object.keys(address).map(part => {
        const value = this.$_.trim(address[part])

        if (value !== '') {
          parts.push(value)
        }
      })

      return parts
    }
  }
}
</script>
